import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faSync, faPlus } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import Swal from 'sweetalert2';
import './CategoriasInventarioData.css';
import baseURL from '../../url';

export default function CategoriasInventarioData() {
    const [categorias, setCategorias] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [categoriaActual, setCategoriaActual] = useState({});
    const [nombre, setNombre] = useState('');
    const [filtro, setFiltro] = useState('');

    useEffect(() => {
        cargarCategorias();
    }, []);

    const cargarCategorias = () => {
        fetch(`${baseURL}/inventarioCategoriasGet.php`)
            .then(response => response.json())
            .then(data => setCategorias(data.categorias || []))
            .catch(error => console.error('Error:', error));
    };

    const abrirModalNuevo = () => {
        setCategoriaActual({});
        setNombre('');
        setModalVisible(true);
    };

    const abrirModalEditar = (categoria) => {
        setCategoriaActual(categoria);
        setNombre(categoria.nombre);
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
        setNombre('');
    };

    const guardarCategoria = () => {
        if (!nombre) {
            toast.error('El nombre es obligatorio');
            return;
        }

        if (categoriaActual.idCategoriaInventario) {
            // Editar
            const payload = { nombre };
            fetch(`${baseURL}/inventarioCategoriasPut.php?idCategoriaInventario=${categoriaActual.idCategoriaInventario}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            })
                .then(response => response.json())
                .then(data => {
                    if (data.error) {
                        toast.error(data.error);
                    } else {
                        Swal.fire('¡Actualizado!', data.mensaje, 'success');
                        cargarCategorias();
                        cerrarModal();
                    }
                })
                .catch(error => toast.error(error.message));
        } else {
            // Crear
            const formData = new FormData();
            formData.append('nombre', nombre);

            fetch(`${baseURL}/inventarioCategoriasPost.php`, {
                method: 'POST',
                body: formData
            })
                .then(response => response.json())
                .then(data => {
                    if (data.error) {
                        toast.error(data.error);
                    } else {
                        Swal.fire('¡Creado!', data.mensaje, 'success');
                        cargarCategorias();
                        cerrarModal();
                    }
                })
                .catch(error => toast.error(error.message));
        }
    };

    const eliminarCategoria = (idCategoriaInventario) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#D83098',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/inventarioCategoriasDelete.php?idCategoriaInventario=${idCategoriaInventario}`, {
                    method: 'DELETE'
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.error) {
                            Swal.fire('Error', data.error, 'error');
                        } else {
                            Swal.fire('¡Eliminado!', data.mensaje, 'success');
                            cargarCategorias();
                        }
                    })
                    .catch(error => toast.error(error.message));
            }
        });
    };

    const categoriasFiltradas = categorias.filter(item =>
        item.nombre.toLowerCase().includes(filtro.toLowerCase())
    );

    return (
        <div>
            <ToastContainer />

            <div className='deFlexContent'>
                <button className='btnPost' onClick={abrirModalNuevo}>
                    <FontAwesomeIcon icon={faPlus} /> Agregar Categoría
                </button>

                <div className='filtrosContain' style={{justifyContent: 'flex-end' }}>
                    <input
                        type="text"
                        placeholder="Buscar categoría"
                        value={filtro}
                        onChange={(e) => setFiltro(e.target.value)}
                        className='filtroInput'
                    />
                    
                </div>
            </div>

            {modalVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <h3>{categoriaActual.idCategoriaInventario ? 'Editar Categoría' : 'Nueva Categoría'}</h3>
                            <span className="close" onClick={cerrarModal}>&times;</span>
                        </div>

                        <fieldset>
                            <legend>Nombre de la categoría</legend>
                            <input type="text" value={nombre} onChange={(e) => setNombre(e.target.value)} />
                        </fieldset>

                        <button className='btnPost' onClick={guardarCategoria}>Guardar</button>
                    </div>
                </div>
            )}

            <div className='table-container'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nombre de la Categoría</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {categoriasFiltradas.map(item => (
                            <tr key={item.idCategoriaInventario}>
                                <td>{item.idCategoriaInventario}</td>
                                <td>{item.nombre}</td>
                                <td>
                                    <button className='editar' onClick={() => abrirModalEditar(item)}>
                                        <FontAwesomeIcon icon={faEdit} />
                                    </button>
                                    <button className='eliminar' onClick={() => eliminarCategoria(item.idCategoriaInventario)}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}




